/**
 * @fileoverview
 * This is the component for the charger advanced controls popup.
 */

import React, { useState } from "react";
import { usePostHog } from "posthog-js/react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverAnchor,
  PopoverClose,
} from "../ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import ChargerAdvancedControlsForm from "./chargerAdvancedControlsForm";
import ResetButton from "../ResetButton";

const ChargerAdvancedControls = () => {
  const posthog = usePostHog();
  const [open, setOpen] = useState(false);

  const handlePopoverOpen = () => {
    posthog?.capture("Charger Advanced Controls Opened");
  };

  const handleOpenChange = (isOpen) => {
    setOpen(isOpen);
    if (isOpen) {
      handlePopoverOpen();
    }
  };



  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}>
      <PopoverAnchor className="absolute right-[250px] top-0 z-50"></PopoverAnchor>
      <PopoverTrigger className="flex items-center justify-center w-full">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="bg-white rounded-full hover:bg-[#e4e6e4] w-[48px] h-[48px]">
                <img
                  className=""
                  src="Icon button.svg"></img>
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Chargers Advanced Controls</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </PopoverTrigger>
      <PopoverContent className="bg-[#FFFFFF] flex flex-col gap-2 overflow-scroll rounded-3xl py-4 px-0 w-[400px]">
        <div className="px-4 py-2 flex justify-between items-start">
          <ResetButton
            buttonType="light"
            tableName="charger costs"
            label="Reset controls to default"
          />
          <PopoverClose className="relative ">
            <img src="XIcon.svg"></img>
          </PopoverClose>
        </div>
        <div className="h-[0px] border-[0.5px] border-[#cacdc9]"></div>
        <div>
          <ChargerAdvancedControlsForm/>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ChargerAdvancedControls;
